import { adminNotificationTemplateQueryKeys as e } from "./adminNotificationTemplateQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminNotificationsApi as n } from "@maat/api-notifications";
//#region src/notifications/admin/useAdminNotificationTemplatesQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: () => n.getTemplates(r)
});
//#endregion
export { r as useAdminNotificationTemplatesQuery };
